<template>
  <!-- 项目卡片 -->
  <div id="project-card" @click="clickProject">
    <!-- 项目封面 -->
    <div class="cover">
      <img v-if="project.coverPath" :src="project.coverPath" alt="" />
      <div v-else class="img">
        <img src="../../../../assets/images/default_cover.png" alt="" />
      </div>
      <!-- <div v-else class="no-exist">
        <img src="../../../../assets/images/nofile.png" alt="" />
        <div class="text">文件不存在！</div>
      </div> -->
    </div>
    <!-- 项目信息 -->
    <div class="info">
      <div class="left">
        <div class="project-name" :title="project.sandName" :class="[filteredProjectMenu.length > 0 ? 'project-name-width-half' : 'project-name-width-full']">{{ project.sandName }}</div>
        <div class="project-time">{{ project.createTime }}</div>
      </div>
      <!-- 下拉菜单 -->
      <div class="right" @click.stop v-if="filteredProjectMenu.length > 0">
        <a-dropdown :trigger="['click']" placement="bottomCenter">
          <a-icon type="dash" size="18px" />
          <a-menu slot="overlay">
            <a-menu-item v-for="(item,index) in filteredProjectMenu" :key="index" @click="editProject(item)">
              <a href="javascript:;">{{ $t(item.label) }}</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </div>
    <!-- 重命名沙盘 -->
    <a-modal :title="$t('project.rename')" :centered="true" :maskClosable="false" :visible="isShowReName" @cancel="handleCancelRealName" :bodyStyle="{'padding-bottom':0}">
      <a-form-model class="form" ref="ruleForm" :model="form" :rules="rules" v-bind="formItemLayout">
        <a-form-model-item class="logger-form-tips" :label="$t('project.sandboxName')" prop="name">
          <a-input :placeholder="$t('project.pleaseInputNewSandboxName')" v-model="form.name" ref="relNameinput" allowClear @pressEnter="handleReNameOk"></a-input>
        </a-form-model-item>
      </a-form-model>
      <div class="modal-footer" slot="footer">
        <a-button class="cancelBtnClass" @click="handleCancelRealName">{{$t('base.cancel')}}</a-button>
        <a-button @click="handleReNameOk()" type="primary">{{$t('base.confirm')}}</a-button>
      </div>
    </a-modal>
    <!-- 删除沙盘 -->
    <a-modal :centered="true" :visible="isShowDelete" :maskClosable="false" :footer="null" :closable="false">
      <div class="content-modal">
        <div class="tip-content">
          <div class="title">
            <img alt="avatar" class="item-icon" src="../../../../assets/images/tips-icon.png" />
            <span>{{$t('project.confirmDeleteSandbox')}}</span>
          </div>
          <div class="tip-text">{{$t('project.deleteAfterYouCanFindInRecycleBin')}}</div>
        </div>
        <div class="bottom-btn">
          <div class="bottom-box">
            <a-button class="cancelBtnClass" @click="isShowDelete = false">{{$t('base.cancel')}}</a-button>
            <a-button type="primary" @click="handleIsDeleteClose">{{$t('base.confirm')}}</a-button>
          </div>
        </div>
      </div>
    </a-modal>
    <!-- 发布沙盘模板 -->
    <TemplateModal ref="templateModal" :sandInfo="project" :templateInfo="templateInfo"></TemplateModal>
    <!-- 分享沙盘 -->
    <ShareSandModal ref="shareSandModal" :isShareVisible.sync="isShareVisible" :sandInfo="project"></ShareSandModal>
  </div>
</template>

<script>
import TemplateModal from './components/TemplateModal.vue'
import { getToken } from '@/utils/auth'

import ShareSandModal from './components/ShareSandModal.vue'
import { deleteSand, renameSand, copySand, queryByTemplateId } from '@/api/workbench'
import { hasPermission } from '@/utils/auth'
export default {
  components: {
    TemplateModal,
    ShareSandModal
  },
  props:{
    project: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {
        name:''
      },
      formItemLayout: {
        // labelCol: { span: 8 },
        // wrapperCol: { span: 16 },
      },
      fileIsExist: true, // 文件是否存在
      isShowReName: false, // 重命名
      isShowDelete: false,
      isShowPublishTableTemplate: false, // 发布沙盘模板
      projectName: '',
      projectMenu: [
        { event: 'preview', label: 'project.preview', show: true, authCode: 'preview_sandbox' },
        { event: 'share', label: 'project.share', show: true, authCode: 'share_sandbox' },
        { event: 'reName', label: 'project.rename', show: true, authCode: 'rename_sandbox' },
        { event: 'newCopy', label: 'project.createCopy', show: true, authCode: 'copy_sandbox' },
        { event: 'publishingTemplate', label: 'project.publishTemplate', show: true, authCode: 'publish_sandbox' },
        { event: 'delete', label: 'project.delete', show: true, authCode: 'del_sandbox' },
      ],
      isShareVisible: false,
      templateInfo: {}, // 模板信息
    }
  },
  computed: {
    rules() {
      return {
        name: [
          {
            required: true,
            message: this.$t('project.pleaseInputSandboxName'),
            trigger: ['blur'],
          },
          {
            pattern: /^(?!_)[\u4e00-\u9fa5A-Za-z0-9_]{1,50}$/,
            message: this.$t('project.templateNameRules',['50']),
            trigger: ['change','blur'],
          },
        ],
      }
    },
    filteredProjectMenu() {
      return this.projectMenu.filter(item => hasPermission(item.authCode))
    }
  },
  methods: {
    handleCancelRealName() {
      this.$refs.ruleForm.resetFields()
      this.isShowReName = false
    },
    async handleReNameOk() {
      await this.$refs.ruleForm.validate()
      try {
        const payload = {
          sandId: this.project.sandId,
          sandName: this.form.name,
        }
        const res = await renameSand(payload)
        if(res.code === 200 || res.status === 0){
          this.handleCancelRealName()
          this.$message.success('重命名成功')
          this.$emit('refreshSandList')
        }
      } catch (error) {
        console.error(error)
      }
    },
    // 沙盘预览
    preview() {
      const token = getToken()
      let href = `${process.env.VUE_APP_BICUBE_SAN_URL}/preview?token=${token}&id=${this.project.projectFkid}&isCloseHide=true`
      window.open(href, '_blank')
    },
    // 点击项目卡片时的处理
    clickProject() {
      const token = getToken()
      let href = `${process.env.VUE_APP_BICUBE_SAN_URL}/home?token=${token}&id=${this.project.projectFkid}&locale=${this.$store.getters.lang}`
      window.open(href, '_blank')
    },
    // 删除
    async handleIsDeleteClose() {
      try {
        const payload = {
          sandId: this.project.sandId,
        }
        const res = await deleteSand(payload)
        this.isShowDelete = false
        this.$message.success('删除成功')
        this.$emit('refreshSandList')
      } catch (error) {
        console.error(error)
      }
    },
    // 工作台-编辑
    editProject(item) {
      if(item.event == 'preview'){
        this.preview()
      }else if (item.event == 'reName') {
        this.form.name = this.project.sandName
        this.isShowReName = true
        this.$nextTick(() => {
          this.$refs.relNameinput.focus()
        })
      } else if (item.event == 'publishingTemplate') {
        queryByTemplateId({ templateId: this.project.sandId }).then((res) => {
          if (res.status === 0) {
            this.templateInfo = res.data
            this.$refs.templateModal.showDialog()
          } else {
            this.templateInfo = {}
          }
        })
      } else if (item.event == 'delete') {
        this.isShowDelete = true
      } else if (item.event == 'newCopy') {
        this.handleCopySand()
      } else if (item.event == 'share') {
        this.isShareVisible = true
      }
    },
    // 创建副本
    async handleCopySand() {
      try {
        const payload = {
          sandId: this.project.sandId,
        }
        const res = await copySand(payload)
        this.$message.success(this.$t('tip.createCopySuccess'))
        this.$emit('refreshSandList')
      } catch (error) {
        console.error(error)
      }
    }
  },
}
</script>

<style scoped lang="less">
#project-card {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .cover {
    height: 172px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #202023;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      vertical-align: middle;
      object-fit: cover;
    }
    .no-exist {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        width: 102px;
        vertical-align: middle;
      }
      .text {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        line-height: 14px;
        margin-top: 18px;
      }
    }
  }
  .info {
    display: flex;
    flex: 1;
    padding: 16px;
    justify-content: space-between;
    .left {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .project-name {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #ffffff;
        line-height: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .project-name-width-half {
        width: 220px;
      }
      .project-name-width-full {
        width: 268px;
      }
      .project-time {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #ffffff;
        line-height: 12px;
        opacity: 0.6;
      }
    }
  }
  .right {
    width: 50px;
    height: 16px;
    display: flex;
    justify-content: flex-end;
    :global(.arco-dropdown-list-wrapper) {
      max-height: fit-content;
    }
  }
  img {
    -webkit-user-drag: none;
  }
}

.cancelBtnClass {
  background: #3c3c3f;
  border: 1px solid #3c3c3f;
  color: #fff;
}

.tip-footer {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content-modal {
  .tip-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .title {
      width: 100%;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #e8e8e9;
      span {
        margin-left: 5px;
      }
    }
    .tip-text {
      margin-top: 10px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #e8e8e9;
    }
  }
  .bottom-btn {
    width: 100%;
    height: 50px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    .bottom-box {
      width: 170px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .itemBtn {
        width: 60px;
        height: 32px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #3c3c3f;
        border-radius: 2px 2px 2px 2px;
      }
      .confirmsBtn {
        background: #0166fc;
      }
    }
  }
}
</style>
